import * as s from './selectors';
import {selectedIngredients} from './selectors';

const moneyFormatters = {};

export function formatMoney(currencyCode, localeCode, money) {
    let formatterKey = currencyCode + localeCode;
    if (!moneyFormatters[formatterKey]) {
        moneyFormatters[formatterKey] = Intl.NumberFormat(localeCode, {
            style: 'currency',
            currency: currencyCode,
        });
    }
    return moneyFormatters[formatterKey].format(money / 100);
}

function getTotalIngredientCountForGroup(group) {
    return group.ingredients.reduce((total, ingredient) => {
        return total + (ingredient.count || 0);
    }, 0);
}

export function getIngredientsGroup(ingredient, groups) {
    return (
        groups.filter((group) => group.code === ingredient.groupCode)[0] || null
    );
}

export function getIngredientsGroupOrThrow(ingredient, groups) {
    const group = getIngredientsGroup(ingredient, groups);
    if (!group) {
        throw new Error(
            `Ingredient ${ingredient.label}:${ingredient.id} has no group`
        );
    }
    return group;
}

export function canAddIngredient(state, ingredient) {
    const groups = s.ingredientGroups(state);
    const ingredientGroup = getIngredientsGroupOrThrow(ingredient, groups);
    return (
        (ingredientGroup.config.MaximumSelected || Number.MAX_SAFE_INTEGER) >
        getTotalIngredientCountForGroup(ingredientGroup)
    );
}

export function canRemoveIngredient(state, ingredient) {
    const groups = s.ingredientGroups(state);
    const ingredientGroup = getIngredientsGroupOrThrow(ingredient, groups);
    return (
        (ingredient.count || 0) > 0 &&
        (ingredientGroup.config.MinimumSelected || 0) <
            getTotalIngredientCountForGroup(ingredientGroup)
    );
}

export function createFormData(state) {
    return {
        sylius_add_to_cart: {
            cartItem: {
                quantity: 1,
                children: selectedIngredients(state).map((ingredient) => ({
                    quantity: ingredient.count,
                    variant: ingredient.id,
                    isIngredient: 1,
                })),
            },
        },
    };
}

function getCurrentQueryString() {
    return new URL(window.location.href).search.slice(1);
}

export function ingredientsToQueryString(selectedIngredients) {
    const searchParams = new URLSearchParams(getCurrentQueryString());
    const ingredients = JSON.stringify(
        selectedIngredients.reduce((reduction, ingredient) => {
            reduction[ingredient.code] = ingredient.count;
            return reduction;
        }, {})
    );
    if (ingredients !== '{}') {
        searchParams.set('ingredients', ingredients);
    } else if (searchParams.has('ingredients')) {
        searchParams.delete('ingredients');
    }
    return searchParams.toString();
}

export function alternateHistory(selectedIngredients) {
    const currentUrl = new URL(window.location.href);
    currentUrl.search = ingredientsToQueryString(selectedIngredients);
    history.replaceState(history.state, document.title, currentUrl.toString());
}

export function ingredientsFromQueryString() {
    return JSON.parse(
        new URLSearchParams(getCurrentQueryString()).get('ingredients') || '{}'
    );
}
